var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_73_420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1480",
    d: "M28 0H0V28H28V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_73_420)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 919"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 531",
    d: "M27.7231 8.39458C27.5902 7.38962 27.2067 6.43422 26.6079 5.61634C25.8656 4.87048 24.8601 4.44595 23.8079 4.43413C19.8918 4.14942 14.0073 4.14941 14.0073 4.14941H14.0014C14.0014 4.14941 8.12281 4.14942 4.20078 4.43413C3.14859 4.44595 2.14311 4.87048 1.40087 5.61634C0.802878 6.43404 0.421591 7.3898 0.292533 8.39458C0.114965 9.89887 0.0199147 11.4118 0.0078125 12.9264V15.0495C0.0195597 16.564 0.112313 18.0768 0.285648 19.5814C0.418144 20.5858 0.800201 21.5409 1.39693 22.3596C2.25033 23.115 3.34594 23.5399 4.4855 23.5576C6.72877 23.7704 14.0073 23.8364 14.0073 23.8364C14.0073 23.8364 19.8918 23.8256 23.8079 23.5468C24.8601 23.5349 25.8656 23.1104 26.6079 22.3645C27.2067 21.5466 27.5902 20.5913 27.7231 19.5863C27.8964 18.0817 27.9892 16.5689 28.0009 15.0545V12.9333C27.9891 11.4188 27.8963 9.90608 27.7231 8.40149M11.1079 17.6337V9.76301L18.6682 13.7116L11.1079 17.6337Z",
    fill: "#2E4455"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeSvg);
export default __webpack_public_path__ + "static/media/youtubeSvg.fa26768ff8657ef37b34e780c33650c6.svg";
export { ForwardRef as ReactComponent };